import { Component } from '@angular/core';

@Component({
  selector: 'app-trip-view-page-root',
  template: `<router-outlet></router-outlet>`
})
export class TripViewPageRootComponent {}
